<template>
  <div class="pt-0 max-h-screen min-h-0 flex flex-col">
    <WrapperQrTickets
      :type-a-p-i="typeAPI"
      v-bind="{ ...settings }"
      :invoice-code="invoiceCode"
      @filled="onPrint()"
    >
    </WrapperQrTickets>
    <WrapperQrTickets
      id="print-section"
      class="print-section"
      v-bind="{ ...settings }"
      :invoice-code="invoiceCode"
      :type-a-p-i="typeAPI"
    ></WrapperQrTickets>
  </div>
</template>

<script>
import WrapperQrTickets from './WrapperQrTickets.vue'
import { putPrintCountApi } from '@/api/reception/reception'

export default {
  components: {
    WrapperQrTickets
  },
  props: {
    invoiceCode: {
      type: String,
      default: null
    },
    openPrinter: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'qrTicket',
      validator(value, props) {
        return ['wrapperQrTickets'].includes(value)
      }
    },
    settings: {
      type: Object
    },
    typeAPI: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {}
  },
  mounted() {
    window.onafterprint = async () => {
      const params = {
        invoiceCode: this.invoiceCode,
        type: 1
      }
      console.log('printedddd')
      await putPrintCountApi(params)
      this.$emit('printed')
    }
  },
  // unmounted(() => {
  //   window.removeEventListener('afterprint')
  // }),
  methods: {
    onPrint() {
      var printSection = document.getElementById('print-section')
      document.getElementsByTagName('html')[0].appendChild(printSection)
      window.print()
      document.getElementsByTagName('html')[0].removeChild(printSection)
    }
  }
}
</script>
<style lang="scss">
.print-section {
  display: none;
}
@media print {
  body {
    display: none;
  }
  // body .testttt {
  //   display: none;
  // }
  .print-section {
    display: block !important;
    // visibility: visible;
    // position: absolute;
    // left: 0;
    // top: 0;
  }

  .el-message {
    display: none;
  }
}
.pt-0 {
  padding-top: 0px;
}
.max-h-screen {
  max-height: 100vh;
}
.min-h-0 {
  min-height: 0px;
}
.flex {
  display: flex;
}
.flex-col {
  flex-direction: column;
}
</style>
